import { AfterViewInit, Component, ComponentFactoryResolver, ElementRef, Inject, Injector, Input, OnDestroy, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { EFormConfiguration, enmEFormViewModes } from '../../../shared-components/e-forms/e-form-config.model';
import { EFormDesignerComponent } from '../../../shared-components/e-forms/e-form-designer/e-form-designer.component';
import { EFormService } from '../../../shared-components/e-forms/e-form.service';
import { EFormDataObject } from '../../../shared-components/e-forms/e-formDataObject.model';
import { FreeReducedMealAppPage } from '../models/free-reduced-meal-app-page.model';
import {cloneDeep, isEqual, isEqualWith, sortBy} from 'lodash';
import { FreeReducedMealAppService } from '../free-reduced-meal-app.service';
import { FreeReducedMealAppPageGroup } from '../models/free-reduced-meal-app-page-group.model';
import { EFormViewerComponent } from '../../../shared-components/e-forms/e-form-viewer/e-form-viewer.component';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { MatHorizontalStepper, MatStep, MatStepper } from '@angular/material/stepper';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Observable, Subscription } from 'rxjs';
import { FreeReducedMealApp } from '../models/free-reduced-meal-app.model';
import { CustomDataTemplateRef } from '../../customization-framework/models/custom-data-template-ref.model';
import { CustomizationFrameworkService } from '../../customization-framework/customization-framework.service';
import { UserService } from '../../../shared-components/user/user.service';
import { FreeReducedMealAppChild } from '../models/free-reduced-meal-app-child.model';
import { StudentService } from '../../../shared-components/student/student.service';
import { FreeReducedMealAppProgram } from '../models/free-reduced-meal-app-program.model';
import { FreeReducedMealAppHouseholdProgram } from '../models/free-reduced-meal-app-household-program.model';
import { FrmaAdultIncomeTypesEnum, FrmaPagesEnum, FrmaProgramsEnum } from '../models/free-reduced-meal-app.enum';
import { FreeReducedMealAppChildProgram } from '../models/free-reduced-meal-app-child-program.model';
import { GeneralConfirmationComponent } from '../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { FreeReducedMealAppChildIncomeType } from '../models/free-reduced-meal-app-child-income-type.model';
import { FreeReducedMealAppAdult } from '../models/free-reduced-meal-app-adult.model';
import { LookupService } from '../../../shared-components/lookup/lookup.service';
import { Lookup } from '../../../shared-components/lookup/lookup.model';
import { FrmaSuffixPipe } from '../pipes/frma-suffix.pipe';
import { FrmaAddPersonComponent } from './frma-add-person/frma-add-person.component';
import { FreeReducedMealAppAdultIncomeType } from '../models/free-reduced-meal-app-adult-income-type.model';
import { FreeReducedMealAppAdultIncomeSubType } from '../models/free-reduced-meal-app-adult-income-sub-type.model';
import { FreeReducedMealAppAdultIncome } from '../models/free-reduced-meal-app-adult-income.model';
import { FreeReducedMealAppInfoSharing } from '../models/free-reduced-meal-app-info-sharing.model';
import { LoginService } from '../../login/login.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { Year } from '../../../shared-components/year/year.model';
import { FreeReducedMealAppCompletedPage } from '../models/free-reduced-meal-app-completed-pages.model';
import { FreeReducedMealAppPerson } from '../models/free-reduced-meal-app-person.model';
import { FrmaPreviousPersonSelectorComponent } from './frma-previous-person-selector/frma-previous-person-selector.component';
import { FrmaChangeHistoryCommentComponent } from '../frma-change-history-comment/frma-change-history-comment.component';
import { PDFDocument } from 'pdf-lib';
import { SpinnerService } from '../../../shared-components/spinner/spinner.service';
import { FrmaChildIncomeDetailsComponent } from './frma-child-income-details/frma-child-income-details.component';
import { FreeReducedMealAppChildIncome } from '../models/free-reduced-meal-app-child-income.model';
import { FrmaAdultIncomeDetailsComponent } from './frma-adult-income-details/frma-adult-income-details.component';
import { FormGroup, NgForm } from '@angular/forms';
import { CheckForErrorsGuard } from '../../../shared-components/guards/check-for-errors/check-for-errors.guard';
import { HasErrors } from '../../../shared-components/guards/check-for-errors/HasErrors';
import { RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@AutoUnsubscribe({includeArrays: true})
@Component({
  selector: 'app-free-reduced-meal-app',
  templateUrl: './free-reduced-meal-app.component.html',
  styleUrls: ['./free-reduced-meal-app.component.css']
})
export class FreeReducedMealAppComponent implements OnInit, AfterViewInit, OnDestroy, HasErrors {

  @ViewChild('frmaContainer', { static: true, read: ViewContainerRef }) frmaContainer: ViewContainerRef;
  @ViewChild(MatHorizontalStepper) stepper: MatHorizontalStepper;

  @ViewChildren(NgForm) forms: QueryList<NgForm>;
  @ViewChildren(FrmaChildIncomeDetailsComponent) childIncomeDetails: QueryList<FrmaChildIncomeDetailsComponent>;
  @ViewChildren(FrmaAdultIncomeDetailsComponent) adultIncomeDetails: QueryList<FrmaAdultIncomeDetailsComponent>;

  // ///// custom templates to inject into form //////////////////////////////////////////////////////////
  customTemplateList: string[] = ['knownStudents', 'signatureCheckbox', 'signatureStamp', 'otherStudentList', 'householdPrograms', 'fosterCareButtons', 'fosterCareStudentList',
    'mckinneyVentoButtons', 'mEPButtons', 'runawayYouthButtons', 'programSummary', 'proceedOrSubmit', 'allStudents', 'nonStudentChildren', 'studentIncomeStudentList', 'childIncomeQuestions'
    , 'childHasIncomeList', 'knownAdults', 'otherAdults', 'adultIncomeTypeQuestions', 'adultIncomeSubTypeQuestions', 'isDeployed', 'ssn', 'noSSN', 'sharingInformationGrid', 'summary'];
  @ViewChild('knownStudents', { static: true }) knownStudents: TemplateRef<any>;
  @ViewChild('signatureCheckbox', { static: true }) signatureCheckbox: TemplateRef<any>;
  @ViewChild('signatureStamp', { static: true }) signatureStamp: TemplateRef<any>;
  @ViewChild('otherStudentList', { static: false }) otherStudentList: TemplateRef<any>;
  @ViewChild('householdPrograms', { static: true }) householdPrograms: TemplateRef<any>;
  @ViewChild('fosterCareButtons', { static: true }) fosterCareButtons: TemplateRef<any>;
  @ViewChild('fosterCareStudentList', { static: true }) fosterCareStudentList: TemplateRef<any>;
  @ViewChild('mckinneyVentoButtons', { static: true }) mckinneyVentoButtons: TemplateRef<any>;
  @ViewChild('mEPButtons', { static: true }) mEPButtons: TemplateRef<any>;
  @ViewChild('runawayYouthButtons', { static: true }) runawayYouthButtons: TemplateRef<any>;
  @ViewChild('programSummary', { static: true }) programSummary: TemplateRef<any>;
  @ViewChild('proceedOrSubmit', { static: true }) proceedOrSubmit: TemplateRef<any>;
  @ViewChild('allStudents', { static: true }) allStudents: TemplateRef<any>;
  @ViewChild('nonStudentChildren', { static: true }) nonStudentChildren: TemplateRef<any>;
  @ViewChild('studentIncomeStudentList', { static: true }) studentIncomeStudentList: TemplateRef<any>;
  @ViewChild('childIncomeQuestions', { static: true }) childIncomeQuestions: TemplateRef<any>;
  @ViewChild('childHasIncomeList', { static: true }) childHasIncomeList: TemplateRef<any>;
  @ViewChild('knownAdults', { static: true }) knownAdults: TemplateRef<any>;
  @ViewChild('otherAdults', { static: true }) otherAdults: TemplateRef<any>;
  @ViewChild('adultIncomeTypeQuestions', { static: true }) adultIncomeTypeQuestions: TemplateRef<any>;
  @ViewChild('adultIncomeSubTypeQuestions', { static: true }) adultIncomeSubTypeQuestions: TemplateRef<any>;
  @ViewChild('isDeployed', { static: true }) isDeployed: TemplateRef<any>;
  @ViewChild('ssn', { static: true }) ssn: TemplateRef<any>;
  @ViewChild('noSSN', { static: true }) noSSN: TemplateRef<any>;
  @ViewChild('sharingInformationGrid', { static: true }) sharingInformationGrid: TemplateRef<any>;
  @ViewChild('summary', { static: true }) summary: TemplateRef<any>;
  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////

  // // element refs for error links //////////////////////////////////
  @ViewChild('signatureRef', {read: ElementRef}) signatureRef: ElementRef<any>;
  @ViewChild('ssnRef', {read: ElementRef}) ssnRef: ElementRef<any>;
  @ViewChild('iCertifyRef', {read: ElementRef}) iCertifyRef: ElementRef<any>;
  @ViewChildren('caseNumberRef ', {read: ElementRef}) caseNumberRefs: QueryList<ElementRef>;
  // //////////////////////////////////////////////////////////////////


  page: FreeReducedMealAppPage;
  isDesignMode: boolean;
  showViewer = false;
  showDesigner = false;
  config = new EFormConfiguration();
  pageTitle = 'Free/Reduced Meal Application';
  pageGroups: FreeReducedMealAppPageGroup[] = [];
  allPages: FreeReducedMealAppPage[] = [];
  selectedStepIndex = 0;
  selectedStep: any;
  errors: ErrorList[] = [];
  isLP = false;
  isFP = true;
  singlePageMode = true;
  subscriptions: Subscription[] = [];
  application: FreeReducedMealApp;
  designPageIndex: number;
  isSigned = false;
  // otherStudents: FreeReducedMealAppChild[] = [];
  // otherChildren: FreeReducedMealAppChild[] = [];
  programs: FreeReducedMealAppProgram[] = [];
  childPrograms: FreeReducedMealAppProgram[] = [];
  isFosterFamily: boolean = null;
  isMckinneyVento: boolean = null;
  isMEP: boolean = null;
  isRunawayYouth: boolean = null;
  frmaPagesEnum = FrmaPagesEnum; // assigned to variable for use in template
  frmaProgramsEnum = FrmaProgramsEnum; // assigned to variable for use in template
  continueOrSubmit: string;
  childIncomeTypes: FreeReducedMealAppChildIncomeType[];
  adultIncomeTypes: FreeReducedMealAppAdultIncomeType[];
  allAdultIncomeSubTypes: FreeReducedMealAppAdultIncomeSubType[];
  adultIncomeSubTypes: FreeReducedMealAppAdultIncomeSubType[];
  selectedChild: FreeReducedMealAppChild;
  selectedAdult: FreeReducedMealAppAdult;
  suffixes: Lookup[];
  mealApplicationConfidentiallyWaiverLookups: Lookup[] = [];
  isCertified = false;
  districtName = '';
  familyWarningShown = false;
  selectedYear: Year;
  mergeFieldTrigger = false;
  previousChildrenChecked = false;
  previousAdultsChecked = false;
  printFlag = false;
  eFormViewerInstance: EFormViewerComponent;
  originalApplication: FreeReducedMealApp;
  appSaved: boolean;
  infoSharingColumns = ['ProgramName', 'No', 'Yes', 'Selected'];
  unenrolledChildren: FreeReducedMealAppChild[] = [];
  unenrolledStudentLabel: string;

  constructor(
    private dialogRef: MatDialogRef<FreeReducedMealAppComponent>,
    private componentFactoryResolver: ComponentFactoryResolver,
    private eFormService: EFormService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private frmaService: FreeReducedMealAppService,
    private customizationFrameworkService: CustomizationFrameworkService,
    private freeReducedMealAppService: FreeReducedMealAppService,
    private userService: UserService,
    private studentService: StudentService,
    private dialog: MatDialog,
    private lookupService: LookupService,
    private suffixPipe: FrmaSuffixPipe,
    private loginService: LoginService,
    private spinnerService: SpinnerService,
    private checkForErrorsGuard: CheckForErrorsGuard,
    private translateService: TranslateService
  ) {
    if (data) {
      this.isDesignMode = data.isDesignMode;
      this.singlePageMode = this.data.singlePageMode;
      this.page = cloneDeep(data.page);
      this.selectedYear = data.selectedYear;
      if (data.appData) {
        this.application = data.appData;
      }
      else {
        this.application = this.freeReducedMealAppService.sampleData();
        this.selectedChild = this.application.Children[0];
        this.selectedAdult = this.application.Adults[0];
        this.unenrolledChildren = cloneDeep(this.application.Children.filter(o => o.IsStudent && !o.IsEnrolled));
      }
    }
    this.designPageIndex = this.customizationFrameworkService.designPageIndexIncrementor++;
    this.districtName = this.loginService.LoginSettings.DistrictName;
   }

  ngOnInit(): void {
    this.subscriptions.push(this.eFormService.observableMergeFieldsRetrievedStream$.subscribe(o => {
      this.updateMergeFieldValues();
    }));
    this.setConfig();
    if (this.singlePageMode) {
      if (this.isDesignMode) {
        this.showDesigner = true;
      }
      this.getSuffixes(null);
    }
    else {
      this.getSuffixes(
        () => {
          this.getFamilyStudents();
          this.getFamilyParents();
          this.setUpApplication();
        }
      );
    }
    this.getPrograms();
    this.getChildIncomeTypes();
    this.getAdultIncomeTypes();
    this.getAdultIncomeSubTypes();
    this.getMealWaiverLookups();
  }

  ngAfterViewInit() {
    if (this.showDesigner && this.page) {
      this.loadDesigner();
    }
    this.interceptStepChange();
    this.loadTemplateControls();
    if (this.singlePageMode && !this.isDesignMode) {
      this.loadViewer(this.page);
    }
  }


  ngOnDestroy() {
    const templatesToRemove: CustomDataTemplateRef[] = this.eFormService.contentTemplates.filter(template => template.DesignPageIndex == this.designPageIndex || !template.DesignPageIndex);

    templatesToRemove.forEach(templateToRemove => {
      const index: number = this.eFormService.contentTemplates.findIndex(template => template.RefName == templateToRemove.RefName);
      if (index > -1) {
        this.eFormService.contentTemplates.splice(index, 1);
      }
    });

    this.frmaService.adultIncomeClicks = {};
    this.frmaService.adultIncomeSubTypeClicks = {};
    this.frmaService.childIncomeClicks = {};
  }

  setConfig() {
    this.config.CustomFieldsFlag = false;
    this.config.ViewMode = enmEFormViewModes.FRMA;
    this.config.AllowSaveToDB = false;
    this.config.AllowPages = false;
    this.config.AllowTabs = false;
    this.config.AllowAttachmentControls = false;
    this.config.UseInstance = false;
    this.config.IsDynamicWidth = true;
    if (this.page) {
      this.pageTitle = this.page.Name;
      this.config.Title = this.page.Name;
    }
    if (!this.isDesignMode) {
      this.config.HideTitle = false;
    }
    if (this.singlePageMode) {
      this.config.AllowConditionalObjects = true;
      this.config.IsPreview = true;
    }
  }

  loadDesigner() {
    this.showViewer = false;
    this.data.config = this.config;
    const allowStudentSpecificMergeFields = this.page.IsSingleChildPage;
    const allowAdultSpecificMergeFields = this.page.IsSingleAdultPage;

    let formData = new EFormDataObject();
    try {
      formData = JSON.parse(this.page.FormData);
    } catch {
      formData = new EFormDataObject();
    }
    this.eFormService.selectedFormData = formData;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(EFormDesignerComponent);

    const viewContainerRef = this.frmaContainer;
    viewContainerRef.clear();
    this.setPageData(this.page);
    const inj = Injector.create({
      providers: [
        {
          provide: MAT_DIALOG_DATA,
          useValue: {config: this.config, allowStudentSpecificMergeFields: allowStudentSpecificMergeFields, allowAdultSpecificMergeFields: allowAdultSpecificMergeFields}
        }
      ]
    });

    const componentRef = viewContainerRef.createComponent(componentFactory, 0, inj);
    componentRef.instance.closeEvent.pipe(take(1)).subscribe((saveClicked: boolean) => {
      if (!saveClicked) {
        this.dialogRef.close(false);
      }
    });

    this.subscriptions.push(componentRef.instance.saveEvent.subscribe((newForm: string) => {
      const commentDialog = this.dialog.open(FrmaChangeHistoryCommentComponent, {
        panelClass: 'tyl-mat-dialog',
        disableClose: true,
      });
      commentDialog.afterClosed().pipe(take(1)).subscribe(comment => {
        this.page.Comment = comment;
        this.page.FormData = newForm;
        this.frmaService.updateFrmaUserTemplate(this.selectedYear.Id, this.page).subscribe(r => {
          this.dialogRef.close(true);
        });
      });
    }));
  }

  loadViewer(page: FreeReducedMealAppPage) {
    let formData = new EFormDataObject();
    try {
      formData = JSON.parse(page.FormData);
    } catch {
      formData = new EFormDataObject();
    }
    this.eFormService.selectedFormData = formData;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(EFormViewerComponent);

    const viewContainerRef = this.frmaContainer;
    viewContainerRef.clear();
    this.setPageData(page);
    const componentRef = viewContainerRef.createComponent(componentFactory);
    this.eFormViewerInstance = componentRef.instance;
    componentRef.instance.config = this.config;
    componentRef.instance.showPrintDiv = this.printFlag;
    if (this.printFlag) {

      this.subscriptions.push(componentRef.instance.renderCompleted.subscribe(o => {
        if (page.ID == this.frmaPagesEnum.CertifyandSubmit) {
          this.renderCompleted();
          if (!this.isLP) {
            this.changePage(this.getNextPageIndex());
          }
          this.printFlag = false;
        }
        else {
          this.errors = [];
          this.validatePage(page);
          if (this.errors.length == 0) {
            this.changePage(this.getNextPageIndex());
          }
          else {
            this.printFlag = false;
            this.spinnerService.showSpinner = false;
            this.loadViewer(page);
          }
        }
      }));
    }
    else {
      this.subscriptions.push(componentRef.instance.renderCompleted.subscribe(o => {
        // this.setPageData(page);
      }));
    }
    this.showViewer = true;
  }

  async renderCompleted() {
    const multiPdfDoc = await PDFDocument.create();

    for (let i = 0; i < this.eFormService.pdfDataURIs.length; i++) {
        const pdfDoc = await PDFDocument.load(this.eFormService.pdfDataURIs[i]);

        for (let j = 0; j < pdfDoc.getPageCount(); j++) {
            const copiedPage = await multiPdfDoc.copyPages(pdfDoc, [j]);
            const [page] = copiedPage;
            multiPdfDoc.addPage(page);
        }
    }

    const pdfBase64 = await multiPdfDoc.saveAsBase64();

    // System.saveFile(pdfBase64, 'pdf', 'FRMA_Test' + '.pdf');
    this.application.ApplicationAsPDF = pdfBase64;

    this.spinnerService.showSpinner = false;

    this.saveApp(false);
}

  setUpApplication() {
    this.frmaService.getFrmaPageGroups().pipe(take(1)).subscribe(groups => {
      this.pageGroups = groups;
      this.interceptStepChange();
    });
    this.frmaService.getFrmaPages(this.selectedYear.Id).pipe(take(1)).subscribe(pages => {
      this.allPages = pages;
      if (pages) {
        this.page = pages[0];
        this.setApplicationData();
        this.loadViewer(this.page);
      }
    });
  }

  interceptStepChange() {
    setTimeout(() => {
      if (this.stepper) {
        this.stepper.steps.forEach((step: MatStep, idx: number) => {
            step.select = () => {
              const previousPageIndex = this.getPreviousPageIndex();
              const previousPageGroupId = this.allPages[previousPageIndex].PageGroupID;
              const previousStepIndex = this.pageGroups.findIndex(o => o.ID == previousPageGroupId);
              if (idx < this.selectedStepIndex && idx <= previousStepIndex) {
                this.errors = [];
                this.validatePage(this.page);
                if (this.errors.length == 0) {
                  const group = this.pageGroups[idx];
                  const newPageIndex = this.allPages.findIndex(o => o.PageGroupID == group.ID);
                  this.changePage(newPageIndex);
                }
              }
            };
        });
      }
    }, 0);
  }

  changePage(newPageIndex: number) {
    const nextPage = this.allPages[newPageIndex];
    if (nextPage.PageGroupID != this.page.PageGroupID) {
      const groupIndex = this.pageGroups.findIndex(o => o.ID == nextPage.PageGroupID);
      this.selectedStepIndex = groupIndex;
    }
    this.page = nextPage;
    if (newPageIndex == 0) {
      this.isFP = true;
    }
    else {
      this.isFP = false;
    }
    if (this.allPages.length == newPageIndex + 1) {
      this.isLP = true;
    }
    else {
      this.isLP = false;
    }
    this.loadViewer(this.page);
  }

  loadTemplateControls() {
    if (!this.eFormService.contentTemplates) {
      this.eFormService.contentTemplates = [];
    }
    this.customTemplateList.forEach(refName => {
      if (this.designPageIndex) {
        this.eFormService.contentTemplates.push(this.generateCustomDataTemplateRef(refName));
      }
    });
  }

  generateCustomDataTemplateRef(refName: string): CustomDataTemplateRef {
    const ref = new CustomDataTemplateRef();
    ref.TemplateRef = this[refName];
    ref.RefName = refName;
    ref.DesignPageIndex = this.designPageIndex;
    return ref;
  }

  // #region Data Methods
  getFamilyStudents() {
    this.freeReducedMealAppService.getFRMAStudentsByFamilyId(this.selectedYear.Id, this.application.FamilyID).pipe(take(1)).subscribe(students => {
      if (this.freeReducedMealAppService.checkForStudentChange(this.application, students)) {
        // student was enrolled or withdrawn since application was started, must create new application
        this.showFamilyChangedWarning();
     }
      else {
        students.forEach(s => {
          if (this.application.ID > 0) {
            // mark unenrolled students
            let frmaChild = this.application.Children.find(o => o.StudentID == s.Id);
              if (frmaChild) {
                if (!s.EnrollDate) {
                  frmaChild.IsEnrolled = false;
                  const childCopy = cloneDeep(frmaChild);
                  childCopy.isSelected = true;
                  this.unenrolledChildren.push(childCopy);
                }
                else {
                  frmaChild.IsEnrolled = true;
                }
              }
              else if (!s.EnrollDate) {
                frmaChild = new FreeReducedMealAppChild();
                if (this.suffixes) {
                  const suffix = this.suffixes.find(sfx => sfx.CodeDescription == s.Suffix);
                  if (suffix) {
                    frmaChild.SuffixID = parseInt(suffix.Id, 10);
                  }
                }
                frmaChild.FirstName = s.FirstName;
                frmaChild.LastName = s.LastName;
                frmaChild.MiddleName = s.MiddleName;
                frmaChild.StudentID = s.Id;
                frmaChild.IsStudent = true;
                frmaChild.IsEnrolled = false;
                this.unenrolledChildren.push(frmaChild);
              }
          }
          else {
            // set up new application
            const frmaChild = new FreeReducedMealAppChild();
            if (this.suffixes) {
              const suffix = this.suffixes.find(sfx => sfx.CodeDescription == s.Suffix);
              if (suffix) {
                frmaChild.SuffixID = parseInt(suffix.Id, 10);
              }
            }
            frmaChild.FirstName = s.FirstName;
            frmaChild.LastName = s.LastName;
            frmaChild.MiddleName = s.MiddleName;
            frmaChild.StudentID = s.Id;
            frmaChild.IsStudent = true;
            if (!s.EnrollDate) {
              frmaChild.IsEnrolled = false;
              this.unenrolledChildren.push(frmaChild);
            }
            else {
              this.application.Children.push(frmaChild);
            }
          }
        });
        this.originalApplication = cloneDeep(this.application);
      }
    });
  }

  getFamilyParents() {
     this.studentService.getHouseholdParentsByFamilyID(this.application.FamilyID).pipe(take(1)).subscribe(parents => {
      if (this.freeReducedMealAppService.checkForParentChange(this.application, parents)) {
        // parent was added or removed since application was started, must start new application
        this.showFamilyChangedWarning();
      }
      else {
        parents.forEach(p => {
          if (!this.application.Adults.find(o => o.PeopleID == p.Id)) {
             // set up new application
            const newParent = new FreeReducedMealAppAdult();
            if (this.suffixes) {
              const suffix = this.suffixes.find(sfx => sfx.CodeDescription == p.Suffix);
              if (suffix) {
                newParent.SuffixID = parseInt(suffix.Id, 10);
              }
            }
            newParent.FirstName = p.FirstName;
            newParent.LastName = p.LastName;
            newParent.MiddleName = p.MiddleName;
            newParent.PeopleID = p.Id;
            this.application.Adults.push(newParent);
          }
        });
        this.originalApplication = cloneDeep(this.application);
      }
    });
  }

  getSuffixes(callback: Function) {
    this.lookupService.getSuffixLookup('').pipe(take(1)).subscribe(suffixes => {
      this.suffixes = suffixes;
      if (callback) {
        callback();
      }
    });
  }

  getPrograms() {
    this.frmaService.getFrmaPrograms().pipe(take(1)).subscribe(programs => {
      this.programs = programs;
      const householdPrograms = programs.filter(o => o.IsHouseholdProgram);
      this.childPrograms = programs.filter(o => o.IsChildProgram);
      householdPrograms.forEach(p => {
        if (!this.application.Programs.find(o => o.ProgramID == p.ID)) {
          const program = new FreeReducedMealAppHouseholdProgram();
          program.ProgramID = p.ID;
          program.Selected = undefined;
          this.application.Programs.push(program);
        }
      });
      this.normalizeChildPrograms();
    });
  }

  normalizeChildPrograms() {
    this.application.Children.forEach(child => {
      if (!child.Programs) {
        child.Programs = [];
      }
      this.childPrograms.forEach(p => {
        if (!child.Programs.find(o => o.ProgramID == p.ID)) {
          const program = new FreeReducedMealAppChildProgram();
          program.ProgramID = p.ID;
          if (this.isDesignMode && this.page.ID == this.frmaPagesEnum.ContinueorSubmit) {
            program.Selected = true;
          }
          else {
            program.Selected = undefined;
          }
          child.Programs.push(program);
        }
      });
    });
    this.originalApplication = cloneDeep(this.application);
  }

  getChildIncomeTypes() {
    this.frmaService.getFrmaChildIncomeTypes().pipe(take(1)).subscribe(incomeTypes => {
      this.childIncomeTypes = incomeTypes;
    });
  }

  getAdultIncomeTypes() {
    this.frmaService.getFrmaAdultIncomeTypes().pipe(take(1)).subscribe(incomeTypes => {
      this.adultIncomeTypes = incomeTypes;
    });
  }

  getAdultIncomeSubTypes() {
    this.frmaService.getFrmaAdultIncomeSubTypes().pipe(take(1)).subscribe(incomeTypes => {
      this.allAdultIncomeSubTypes = incomeTypes;
      this.filterAdultIncomeSubTypes(this.page);
    });
  }

  getMealWaiverLookups() {
    this.lookupService.getMealApplicationConfidentiallyWaiverLookups().pipe(take(1)).subscribe(lookups => {
      this.mealApplicationConfidentiallyWaiverLookups = lookups;
      this.normalizeMealWaiverPrograms();
    });
  }

  normalizeMealWaiverPrograms() {
    if (this.application && this.mealApplicationConfidentiallyWaiverLookups) {
      const initialPrograms = this.application.InfoSharing ? cloneDeep(this.application.InfoSharing) : [];
      this.application.InfoSharing = [];
      sortBy(this.mealApplicationConfidentiallyWaiverLookups, 'Sequence').forEach(program => {
        if (!isNaN(Number(program.Id))) {
          const p = initialPrograms.find(o => o.WaiverProgramID == Number(program.Id));
          if (p) {
            p.ProgramName = program.CodeDescription;
            this.application.InfoSharing.push(p);
          }
          else {
            const newProgram = new FreeReducedMealAppInfoSharing();
            newProgram.ProgramName = program.CodeDescription;
            newProgram.WaiverProgramID = Number(program.Id);
            newProgram.AppID = this.application.ID;
            newProgram.StudentIds = [];
            this.application.InfoSharing.push(newProgram);
          }
        }
      });
    }
    this.originalApplication = cloneDeep(this.application);
  }

  // eslint-disable-next-line complexity
  validatePage(page: FreeReducedMealAppPage) {
    this.markAsTouched();
    switch (page.ID) {
      case FrmaPagesEnum.Signature: {
        if (!this.isSigned && (!this.application.SignedBy || this.application.SignedBy <= 0)) {
          this.errors.push({
            fieldName: 'Electronic Signature',
            fieldRef: this.signatureRef,
            errorMsg: 'must be checked.'
          });
        }
        break;
      }
      case FrmaPagesEnum.AssistancePrograms: {
        let refIndex = 0;
        for (let i = 0; i < this.application.Programs.length; i++) {
          const program = this.application.Programs[i];
          if (program.Selected) {
            const elementRef = this.caseNumberRefs.find((_, e) => e == i);
            refIndex++;
            if (!program.CaseNumber) {
              const p = this.programs.find(o => o.ID == program.ProgramID);
              this.errors.push({
                fieldName: p.ShortName + ' Case Number',
                fieldRef: elementRef,
                errorMsg: 'is required.'
              });
            }
          }
        }
        break;
      }
      case FrmaPagesEnum.FosterCare: {
        if (this.isFosterFamily == null) {
          this.errors.push({
            fieldName: 'Foster Care',
            fieldRef: null,
            errorMsg: 'is required.'
          });
        }
        else if (this.isFosterFamily && this.application.Children.find(o => o.IsFosterChild) == null) {
          this.errors.push({
            fieldName: 'Foster Care',
            fieldRef: null,
            errorMsg: 'At least one student must be selected.'
          });
        }
        break;
      }
      case FrmaPagesEnum.YourChildrenCanAlsoQualify: {
        if (this.isMckinneyVento == null) {
          this.errors.push({
            fieldName: 'McKinney-Vento',
            fieldRef: null,
            errorMsg: 'is required.'
          });
        }
        else if (this.isMckinneyVento && this.application.Children.find(c => c.Programs.find(p => p.ProgramID == FrmaProgramsEnum.McKinneyVento && p.Selected)) == null) {
          this.errors.push({
            fieldName: 'McKinney-Vento',
            fieldRef: null,
            errorMsg: 'At least one student must be selected.'
          });
        }
        if (this.isMEP == null) {
          this.errors.push({
            fieldName: 'MEP',
            fieldRef: null,
            errorMsg: 'is required.'
          });
        }
        else if (this.isMEP && this.application.Children.find(c => c.Programs.find(p => p.ProgramID == FrmaProgramsEnum.MEP && p.Selected)) == null) {
          this.errors.push({
            fieldName: 'MEP',
            fieldRef: null,
            errorMsg: 'At least one student must be selected.'
          });
        }
        if (this.isRunawayYouth == null) {
          this.errors.push({
            fieldName: 'Runaway Youth',
            fieldRef: null,
            errorMsg: 'is required.'
          });
        }
        else if (this.isRunawayYouth && this.application.Children.find(c => c.Programs.find(p => p.ProgramID == FrmaProgramsEnum.RunawayYouth && p.Selected)) == null) {
          this.errors.push({
            fieldName: 'Runaway Youth',
            fieldRef: null,
            errorMsg: 'At least one student must be selected.'
          });
        }
        break;
      }
      case FrmaPagesEnum.ContinueorSubmit: {
        if (!this.continueOrSubmit) {
          this.errors.push({
            fieldName: 'Do you want to',
            fieldRef: null,
            errorMsg: 'is required.'
          });
        }
        break;
      }
      case FrmaPagesEnum.TheNextFewQuestionsAreAboutYourChildrensIncome: {
        this.application.Children.forEach(child => {
          if (child.HasIncome == null) {
            this.errors.push({
              fieldName: 'Does ' + this.frmaService.formatName(child.FirstName, child.MiddleName, child.LastName, this.suffixPipe.transform(child.SuffixID, this.suffixes)) + ' have income',
              fieldRef: null,
              errorMsg: 'is required.'
            });
          }
        });
        break;
      }
      case FrmaPagesEnum.DoesStudentHaveIncomeFromAnyOfTheFollowingSources: {
        if (this.selectedChild) {
          if (!this.application.ID || this.application.ID <= 0 || !this.frmaService.pageHasBeenCompleted(this.application, page, this.selectedChild, this.selectedAdult)) {
            this.childIncomeTypes.forEach(type => {
              if (!this.selectedChild.Income.find(o => o.ChildIncomeTypeID == type.ID)) {
                const dict = this.frmaService.childIncomeClicks[this.selectedChild.ID];
                if (!dict || dict[type.ID] == null) {
                  this.errors.push({
                    fieldName: type.ShortName,
                    fieldRef: null,
                    errorMsg: 'is required.'
                  });
                }
              }
            });
          }
          if (this.selectedChild.Income.length == 0) {
            this.errors.push({
              fieldName: null,
              fieldRef: null,
              errorMsg: 'On a previous page, you indicated that ' + this.frmaService.formatName(this.selectedChild.FirstName, this.selectedChild.MiddleName, this.selectedChild.LastName, this.suffixPipe.transform(this.selectedChild.SuffixID, this.suffixes)) + ' receives income. Please enter this income above or correct your previous answer.'
            });
          }
          else {
            this.selectedChild.Income.forEach(i => {
              if (!i.Amount) {
                this.errors.push({
                  fieldName: 'Amount',
                  fieldRef: this.getChildIncomeElementRef(i, 'amount'),
                  errorMsg: 'is required.'
                });
              }
              else {
                if (isNaN(Number(i.Amount))) {
                  this.errors.push({
                    fieldName: 'Amount',
                    fieldRef: this.getChildIncomeElementRef(i, 'amount'),
                    errorMsg: 'must be a number.'
                  });
                }
                else if (i.Amount <= 0) {
                  this.errors.push({
                    fieldName: 'Amount',
                    fieldRef: this.getChildIncomeElementRef(i, 'amount'),
                    errorMsg: 'must be greater than zero.'
                  });
                }
              }
              if (!i.Frequency) {
                this.errors.push({
                  fieldName: 'Frequency',
                  fieldRef: this.getChildIncomeElementRef(i, 'frequency'),
                  errorMsg: 'is required.'
                });
              }
              if (i.Frequency == 'hourly') {
                if (!i.Hours) {
                  this.errors.push({
                    fieldName: 'Hours',
                    fieldRef: this.getChildIncomeElementRef(i, 'hours'),
                    errorMsg: 'is required.'
                  });
                }
                else {
                  if (isNaN(Number(i.Hours))) {
                    this.errors.push({
                      fieldName: 'Hours',
                      fieldRef: this.getChildIncomeElementRef(i, 'hours'),
                      errorMsg: 'must be a number.'
                    });
                  }
                  else if (i.Hours <= 0) {
                    this.errors.push({
                      fieldName: 'Hours',
                      fieldRef: this.getChildIncomeElementRef(i, 'hours'),
                      errorMsg: 'must be greater than zero.'
                    });
                  }
                  else {
                    let maxHours = 744; // max hours in a month
                    if (i.Per == 'Week') {
                      maxHours = 168;
                    }
                    if (i.Hours > maxHours) {
                      this.errors.push({
                        fieldName: 'Hours',
                        fieldRef: this.getChildIncomeElementRef(i, 'hours'),
                        errorMsg: 'Please enter a valid number of hours.'
                      });
                    }
                  }
                }
                if (!i.Per) {
                  this.errors.push({
                    fieldName: 'Per',
                    fieldRef: this.getChildIncomeElementRef(i, 'per'),
                    errorMsg: 'is required.'
                  });
                }
              }
            });
          }
        }
        break;
      }
      case FrmaPagesEnum.TheNextQuestionsAreAllAboutNameOfAdult: {
        if (this.selectedAdult && (!this.application.ID || this.application.ID <= 0 || !this.frmaService.pageHasBeenCompleted(this.application, page, this.selectedChild, this.selectedAdult))) {
          this.adultIncomeTypes.forEach(o => {
            if (!this.selectedAdult.IncomeTypeIds.includes(o.ID)) {
              const dict = this.frmaService.adultIncomeClicks[this.selectedAdult.ID];
              if (!dict || dict[o.ID] == null) {
                this.errors.push({
                  fieldName: o.Question.replace('<<Adult Name>>', this.frmaService.formatName(this.selectedAdult.FirstName, this.selectedAdult.MiddleName, this.selectedAdult.LastName, this.suffixPipe.transform(this.selectedAdult.SuffixID, this.suffixes))),
                  fieldRef: null,
                  errorMsg: 'is required.'
                });
              }
            }
          });
        }
        break;
      }
      case FrmaPagesEnum.MilitaryIncome: {
        if (this.selectedAdult.IsDeployed == null) {
          this.errors.push({
            fieldName: 'Is ' + this.frmaService.formatName(this.selectedAdult.FirstName, this.selectedAdult.MiddleName, this.selectedAdult.LastName, this.suffixPipe.transform(this.selectedAdult.SuffixID, this.suffixes)) + ' currently deployed?',
            fieldRef: null,
            errorMsg: 'is required.'
          });
        }
        if (!this.application.ID || this.application.ID <= 0 || !this.frmaService.pageHasBeenCompleted(this.application, page, this.selectedChild, this.selectedAdult)) {
          const dict = this.frmaService.adultIncomeSubTypeClicks[this.selectedAdult.ID];
          const subTypes = this.adultIncomeSubTypes.filter(o => o.AdultIncomeTypeID == this.frmaService.getAdultIncomeTypeByPage(page.ID));
          subTypes.forEach(t => {
            if (!this.selectedAdult.Income.find(o => o.AdultIncomeSubTypeID == t.ID)) {
              if (!dict || dict[t.ID] == null) {
                this.errors.push({
                  fieldName: t.Name,
                  fieldRef: null,
                  errorMsg: 'is required.'
                });
              }
            }
          });
        }
        this.validateAdultIncome(this.selectedAdult.Income, page.ID);
        break;
      }
      case FrmaPagesEnum.EarningsFromWork:
      case FrmaPagesEnum.IncomeFromPublicAssistance:
      case FrmaPagesEnum.IncomeFromAlimonyorChildSupport:
      case FrmaPagesEnum.IncomeFromBenefits:
      case FrmaPagesEnum.RetirementIncome:
      case FrmaPagesEnum.OtherSourcesofIncome:
        if (!this.application.ID || this.application.ID <= 0 || !this.frmaService.pageHasBeenCompleted(this.application, page, this.selectedChild, this.selectedAdult)) {
          const dict = this.frmaService.adultIncomeSubTypeClicks[this.selectedAdult.ID];
          const subTypes = this.adultIncomeSubTypes.filter(o => o.AdultIncomeTypeID == this.frmaService.getAdultIncomeTypeByPage(page.ID));
          subTypes.forEach(t => {
            if (!this.selectedAdult.Income.find(o => o.AdultIncomeSubTypeID == t.ID)) {
              if (!dict || dict[t.ID] == null) {
                this.errors.push({
                  fieldName: t.Name,
                  fieldRef: null,
                  errorMsg: 'is required.'
                });
              }
            }
          });
        }
        this.validateAdultIncome(this.selectedAdult.Income, page.ID);
        break;
      case FrmaPagesEnum.AlmostDone: {
        if (!this.application.NoSSN) {
          if (!this.application.LastFourSSN) {
            this.errors.push({
              fieldName: null,
              fieldRef: null,
              errorMsg: 'You must either provide the four digits or check No SSN.'
            });
          }
          else if (this.application.LastFourSSN.length != 4) {
            this.errors.push({
              fieldName: 'Last Four Digits',
              fieldRef: this.ssnRef,
              errorMsg: 'Please provide only the last four digits of the Social Security number.'
            });
          }
          else if (isNaN(Number(this.application.LastFourSSN))) {
            this.errors.push({
              fieldName: 'Last Four Digits',
              fieldRef: this.ssnRef,
              errorMsg: 'Please provide only the last four digits of the Social Security number.'
            });
          }
        }
        else if (this.application.LastFourSSN) {
          this.errors.push({
            fieldName: null,
            fieldRef: null,
            errorMsg: 'Do not check No SSN if you have provided the last four digits of your Social Security number.'
          });
        }
        break;
      }
      case FrmaPagesEnum.SharingInformationwithOtherPrograms: {
        this.application.InfoSharing.forEach(o => {
          if (!o.ShareWith) {
            this.errors.push({
              fieldName: this.formatErrorFieldname(o.ProgramName),
              fieldRef: null,
              errorMsg: 'Yes or No must be selected.'
            });
          }
          else if (o.ShareWith == 'selected' && (!o.StudentIds || o.StudentIds.length == 0)) {
            this.errors.push({
              fieldName: this.formatErrorFieldname(o.ProgramName),
              fieldRef: null,
              errorMsg: 'Select at least one student.'
            });
          }
        });
        break;
      }
      case FrmaPagesEnum.CertifyandSubmit: {
        if (!this.isCertified && (!this.application.CertifiedBy || this.application.CertifiedBy <= 0)) {
          this.errors.push({
            fieldName: 'I certify...',
            fieldRef: this.iCertifyRef,
            errorMsg: 'must be checked before the application can be submitted.'
          });
        }
        break;
      }
    }
  }

  markAsTouched() {
    if (this.eFormViewerInstance) {
      this.eFormViewerInstance.validateButton.nativeElement.click();
    }
    this.adultIncomeDetails.forEach(o => {
      o.markAsTouched();
    });
    this.childIncomeDetails.forEach(o => {
      o.markAsTouched();
    });
    this.forms.forEach(form => {
      Object.keys((<FormGroup>form.form).controls).forEach(control => {
        form.form.get(control).markAsTouched();
      });
    });
  }

  formatErrorFieldname(fieldName: string): string {
    if (fieldName.length > 15) {
      return fieldName.substring(0, 15) + '...';
    }
    else {
      return fieldName;
    }
  }

  setApplicationData() {
    if (this.application) {
      if (this.application.SignedBy > 0) {
        this.isSigned = true;
      }
      if (this.application.Children && this.application.Children.length > 0) {
        this.isFosterFamily = this.application.Children.find(o => o.IsFosterChild) != null;
        this.isMckinneyVento = this.application.Children.find(o => o.Programs.find(p => p.ProgramID == FrmaProgramsEnum.McKinneyVento && p.Selected)) != null;
        this.isMEP = this.application.Children.find(o => o.Programs.find(p => p.ProgramID == FrmaProgramsEnum.MEP && p.Selected)) != null;
        this.isRunawayYouth = this.application.Children.find(o => o.Programs.find(p => p.ProgramID == FrmaProgramsEnum.RunawayYouth && p.Selected)) != null;
        const fosterPage = this.allPages.find(o => o.ID == this.frmaPagesEnum.FosterCare);
        const programPage = this.allPages.find(o => o.ID == this.frmaPagesEnum.YourChildrenCanAlsoQualify);
        if (!this.isFosterFamily && (!fosterPage || !this.frmaService.pageHasBeenCompleted(this.application, fosterPage, this.selectedChild, this.selectedAdult))) {
          this.isFosterFamily = null;
        }
        if (!programPage || !this.frmaService.pageHasBeenCompleted(this.application, programPage, this.selectedChild, this.selectedAdult)) {
          if (!this.isMckinneyVento) {
            this.isMckinneyVento = null;
          }
          if (!this.isMEP) {
            this.isMEP = null;
          }
          if (!this.isRunawayYouth) {
            this.isRunawayYouth = null;
          }
        }
        this.application.Children.forEach(child => {
          const childIncomePage = this.allPages.find(o => o.ID == this.frmaPagesEnum.TheNextFewQuestionsAreAboutYourChildrensIncome);
          if (!child.HasIncome && (!childIncomePage || !this.frmaService.pageHasBeenCompleted(this.application, childIncomePage, child, null))) {
            child.HasIncome = null;
          }
        });
      }
      if (this.application.CertifiedBy > 0) {
        this.isCertified = true;
      }
    }
    this.originalApplication = cloneDeep(this.application);
  }

  // setOtherStudents() {
  //   this.otherStudents = this.application.Children.filter(o => o.IsStudent && !o.StudentID);
  //   this.otherChildren = this.application.Children.filter(o => !o.IsStudent);
  // }

  getChildIncomeElementRef(i: FreeReducedMealAppChildIncome, field: string): ElementRef {
    const details = this.childIncomeDetails.find(o => o.childIncomeType.ID == i.ChildIncomeTypeID);
    if (details) {
      return details.getElementReference(i, field);
    }
    else {
      return null;
    }
  }

  getAdultIncomeElementRef(i: FreeReducedMealAppAdultIncome, field: string): ElementRef {
    const details = this.adultIncomeDetails.find(o => o.adultIncomeSubType.ID == i.AdultIncomeSubTypeID);
    if (details) {
      return details.getElementReference(i, field);
    }
    else {
      return null;
    }
  }

  validateAdultIncome(adultIncome: FreeReducedMealAppAdultIncome[], pageId: FrmaPagesEnum) {
    const subTypeIds = this.adultIncomeSubTypes.filter(o => o.AdultIncomeTypeID == this.frmaService.getAdultIncomeTypeByPage(pageId)).map(o => o.ID);
    const filteredIncome = adultIncome.filter(o => subTypeIds.includes(o.AdultIncomeSubTypeID));
    if (filteredIncome.length == 0) {
      this.errors.push({
        fieldName: null,
        fieldRef: null,
        errorMsg: 'On a previous page, you indicated ' + this.frmaService.formatName(this.selectedAdult.FirstName, this.selectedAdult.MiddleName, this.selectedAdult.LastName, this.suffixPipe.transform(this.selectedAdult.SuffixID, this.suffixes)) + ' receives income from one of the above sources. Please enter this income or correct your previous answer.'
      });
    }
    else {
      filteredIncome.forEach(i => {
        if (!i.Amount) {
          this.errors.push({
            fieldName: 'Amount',
            fieldRef: this.getAdultIncomeElementRef(i, 'amount'),
            errorMsg: 'is required.'
          });
        }
        else {
          if (isNaN(Number(i.Amount))) {
            this.errors.push({
              fieldName: 'Amount',
              fieldRef: this.getAdultIncomeElementRef(i, 'amount'),
              errorMsg: 'must be a number.'
            });
          }
          else if (i.Amount <= 0) {
            this.errors.push({
              fieldName: 'Amount',
              fieldRef: this.getAdultIncomeElementRef(i, 'amount'),
              errorMsg: 'must be greater than zero.'
            });
          }
        }
        if (!i.Frequency) {
          this.errors.push({
            fieldName: 'Frequency',
            fieldRef: this.getAdultIncomeElementRef(i, 'frequency'),
            errorMsg: 'is required.'
          });
        }
        if (i.Frequency == 'hourly') {
          if (!i.Hours) {
            this.errors.push({
              fieldName: 'Hours',
              fieldRef: this.getAdultIncomeElementRef(i, 'hours'),
              errorMsg: 'is required.'
            });
          }
          else {
            if (isNaN(Number(i.Hours))) {
              this.errors.push({
                fieldName: 'Hours',
                fieldRef: this.getAdultIncomeElementRef(i, 'hours'),
                errorMsg: 'must be a number.'
              });
            }
            else if (i.Hours <= 0) {
              this.errors.push({
                fieldName: 'Hours',
                fieldRef: this.getAdultIncomeElementRef(i, 'hours'),
                errorMsg: 'must be greater than zero.'
              });
            }
            else {
              let maxHours = 744; // max hours in a month
              if (i.Per == 'Week') {
                maxHours = 168;
              }
              if (i.Hours > maxHours) {
                this.errors.push({
                  fieldName: 'Hours',
                  fieldRef: this.getAdultIncomeElementRef(i, 'hours'),
                  errorMsg: 'Please enter a valid number of hours.'
                });
              }
            }
          }
          if (!i.Per) {
            this.errors.push({
              fieldName: 'Per',
              fieldRef: this.getAdultIncomeElementRef(i, 'per'),
              errorMsg: 'is required.'
            });
          }
        }
      });
    }
  }

  setPageData(page: FreeReducedMealAppPage) {
    this.filterAdultIncomeSubTypes(page);
    this.updateMergeFieldValues();
    this.checkForPreviousChildren();
    this.checkForPreviousAdults();
    this.setInfoSharingColumns();
    this.setUnenrolledStudentLabel();
  }

  updateMergeFieldValues() {
    if (this.selectedChild) {
      const mergeField = this.eFormService.mergeFields.find(o => o.FieldName == '<<Child Name>>' && o.UseOnFRMA);
      if (mergeField) {
        mergeField.Value = this.frmaService.formatName(this.selectedChild.FirstName, this.selectedChild.MiddleName, this.selectedChild.LastName, this.suffixPipe.transform(this.selectedChild.SuffixID, this.suffixes));
      }
    }
    if (this.selectedAdult) {
      const mergeField = this.eFormService.mergeFields.find(o => o.FieldName == '<<Adult Name>>' && o.UseOnFRMA);
      if (mergeField) {
        mergeField.Value = this.frmaService.formatName(this.selectedAdult.FirstName, this.selectedAdult.MiddleName, this.selectedAdult.LastName, this.suffixPipe.transform(this.selectedAdult.SuffixID, this.suffixes));
      }
    }
    const districtMergeField = this.eFormService.mergeFields.find(o => o.FieldName == '<<District Name>>' && o.UseOnFRMA);
    if (districtMergeField) {
      districtMergeField.Value = this.loginService.LoginSettings.DistrictName;
    }
    const yearMergeField = this.eFormService.mergeFields.find(o => o.FieldName == '<<Selected Year>>' && o.UseOnFRMA);
    if (yearMergeField) {
      yearMergeField.Value = this.selectedYear.Description;
    }
    this.mergeFieldTrigger = !this.mergeFieldTrigger;
  }

  filterAdultIncomeSubTypes(page: FreeReducedMealAppPage) {
    this.adultIncomeSubTypes = [];
    if (page && this.allAdultIncomeSubTypes) {
      switch (page.ID) {
        case FrmaPagesEnum.MilitaryIncome:
          this.adultIncomeSubTypes = this.allAdultIncomeSubTypes.filter(o => o.AdultIncomeTypeID == FrmaAdultIncomeTypesEnum.Military);
          break;
        case FrmaPagesEnum.EarningsFromWork:
          this.adultIncomeSubTypes = this.allAdultIncomeSubTypes.filter(o => o.AdultIncomeTypeID == FrmaAdultIncomeTypesEnum.Employment);
          break;
        case FrmaPagesEnum.IncomeFromPublicAssistance:
          this.adultIncomeSubTypes = this.allAdultIncomeSubTypes.filter(o => o.AdultIncomeTypeID == FrmaAdultIncomeTypesEnum.PublicAssistance);
          break;
        case FrmaPagesEnum.IncomeFromAlimonyorChildSupport:
          this.adultIncomeSubTypes = this.allAdultIncomeSubTypes.filter(o => o.AdultIncomeTypeID == FrmaAdultIncomeTypesEnum.AlimonyChildSupport);
          break;
        case FrmaPagesEnum.IncomeFromBenefits:
          this.adultIncomeSubTypes = this.allAdultIncomeSubTypes.filter(o => o.AdultIncomeTypeID == FrmaAdultIncomeTypesEnum.Benefits);
          break;
        case FrmaPagesEnum.RetirementIncome:
          this.adultIncomeSubTypes = this.allAdultIncomeSubTypes.filter(o => o.AdultIncomeTypeID == FrmaAdultIncomeTypesEnum.Retirement);
          break;
        case FrmaPagesEnum.OtherSourcesofIncome:
          this.adultIncomeSubTypes = this.allAdultIncomeSubTypes.filter(o => o.AdultIncomeTypeID == FrmaAdultIncomeTypesEnum.Other);
          break;
        default:
          break;
      }
    }
  }

  setSelectedChild(child: FreeReducedMealAppChild) {
    this.selectedChild = child;
    // const mergeField = this.eFormService.mergeFields.find(o => o.FieldName == '<<Child Name>>' && o.UseOnFRMA);
    // if (mergeField) {
    //   mergeField.Value = this.frmaService.formatName(child.FirstName, child.MiddleName, child.LastName, this.suffixPipe.transform(child.SuffixID, this.suffixes));
    // }
  }

  setSelectedAdult(adult: FreeReducedMealAppAdult) {
    this.selectedAdult = adult;
    // const mergeField = this.eFormService.mergeFields.find(o => o.FieldName == '<<Adult Name>>' && o.UseOnFRMA);
    // if (mergeField) {
    //   mergeField.Value = this.frmaService.formatName(adult.FirstName, adult.MiddleName, adult.LastName, this.suffixPipe.transform(adult.SuffixID, this.suffixes));
    // }
  }

  showFamilyChangedWarning() {
    if (!this.familyWarningShown) {
      this.familyWarningShown = true;
      const warningDialog = this.dialog.open(GeneralConfirmationComponent, {
        panelClass: 'tyl-mat-dialog',
        disableClose: true,
      });
      const firstBlock = marker('The members of your household have changed since you started this application, so it cannot be edited.').toString();
      const secondBlock = marker('You will need to start a new application.').toString();
      const title = marker('UNABLE TO EDIT').toString();
      warningDialog.componentInstance.headerLabel = title;
      warningDialog.componentInstance.confirmMessage = firstBlock;
      warningDialog.componentInstance.secondMessage = secondBlock;
      warningDialog.componentInstance.warning = true;
      warningDialog.componentInstance.headerCenterAlign = true;
      warningDialog.componentInstance.informational = true;
      warningDialog.afterClosed().pipe(take(1)).subscribe(() => {
        this.dialogRef.close(false);
      });
    }
  }

  setCompletedPage(page: FreeReducedMealAppPage) {
    const completedPage = new FreeReducedMealAppCompletedPage();
    completedPage.PageID = page.ID;
    if (page.IsSingleChildPage && this.selectedChild) {
      completedPage.ChildID = this.selectedChild.ID;
    }
    if (page.IsSingleAdultPage && this.selectedAdult) {
      completedPage.AdultID = this.selectedAdult.ID;
    }
    if (this.application.CompletedPages.find(o => o.PageID == completedPage.PageID && o.ChildID == completedPage.ChildID && o.AdultID == completedPage.AdultID) == null) {
      this.application.CompletedPages.push(completedPage);
    }
  }

  checkForPreviousChildren() {
    if (this.page.ID == this.frmaPagesEnum.OtherChildrenInTheHousehold && !this.previousChildrenChecked && !this.frmaService.pageHasBeenCompleted(this.application, this.page, this.selectedChild, this.selectedAdult)) {
      this.frmaService.getFrmaPreviousChildren(this.application.FamilyID, this.selectedYear.Id).pipe(take(1)).subscribe(children => {
        if (children) {
          const previousChildren: FreeReducedMealAppChild[] = [];
          children.forEach(c => {
            if (!this.application.Children.find(o => o.FirstName == c.FirstName && o.MiddleName == c.MiddleName && o.LastName == c.LastName && o.SuffixID == c.SuffixID)) {
              c.ID = FreeReducedMealAppPerson.frmaPersonIncrementor--;
              previousChildren.push(c);
            }
          });
          if (previousChildren.length > 0) {
            const dialogBox = this.dialog.open(FrmaPreviousPersonSelectorComponent, {
              disableClose: true,
              width: '450px',
              data: {
                previousPeople: previousChildren,
                suffixes: this.suffixes,
                isChildren: true
              }
            });
            dialogBox.afterClosed().pipe(take(1)).subscribe((selectedChildren: FreeReducedMealAppChild[]) => {
              this.previousChildrenChecked = true;
              if (selectedChildren && selectedChildren.length > 0) {
                selectedChildren.forEach(selectedChild => {
                  this.application.Children.push(selectedChild);
                });
                this.application.Children = cloneDeep(this.application.Children); // reassign for change detection
              }
            });
          }
        }
      });
    }
  }

  checkForPreviousAdults() {
    if (this.page.ID == this.frmaPagesEnum.WhatAdultsLiveInYourHousehold && !this.previousAdultsChecked && !this.frmaService.pageHasBeenCompleted(this.application, this.page, this.selectedChild, this.selectedAdult)) {
      this.frmaService.getFrmaPreviousAdults(this.application.FamilyID, this.selectedYear.Id).pipe(take(1)).subscribe(adults => {
        if (adults) {
          const previousAdults: FreeReducedMealAppAdult[] = [];
          adults.forEach(c => {
            if (!this.application.Adults.find(o => o.FirstName == c.FirstName && o.MiddleName == c.MiddleName && o.LastName == c.LastName && o.SuffixID == c.SuffixID)) {
              c.ID = FreeReducedMealAppPerson.frmaPersonIncrementor--;
              previousAdults.push(c);
            }
          });
          if (previousAdults.length > 0) {
            const dialogBox = this.dialog.open(FrmaPreviousPersonSelectorComponent, {
              disableClose: true,
              width: '450px',
              data: {
                previousPeople: previousAdults,
                suffixes: this.suffixes,
                isAdults: true
              }
            });
            dialogBox.afterClosed().pipe(take(1)).subscribe((selectedAdults: FreeReducedMealAppAdult[]) => {
              this.previousAdultsChecked = true;
              if (selectedAdults && selectedAdults.length > 0) {
                selectedAdults.forEach(selectedAdult => {
                  this.application.Adults.push(selectedAdult);
                });
                this.application.Adults = cloneDeep(this.application.Adults); // reassign for change detection
              }
            });
          }
        }
      });
    }
  }

  setInfoSharingColumns() {
    if (this.page.ID == this.frmaPagesEnum.SharingInformationwithOtherPrograms) {
      if (this.application.Children && this.application.Children.filter(o => o.IsStudent && o.StudentID > 0).length > 1) {
        this.infoSharingColumns = ['ProgramName', 'No', 'Yes', 'Selected'];
      }
      else {
        this.infoSharingColumns = ['ProgramName', 'No', 'Yes'];
      }
    }
  }

  setUnenrolledStudentLabel() {
    if (this.page.ID == this.frmaPagesEnum.StudentsInTheHousehold && !this.unenrolledStudentLabel) {
      const translated = this.translateService.instant('Our records also show other children associated with your household who are not currently enrolled for {1}.<br /><b>Please select any of these who will be attending {2} in {1}:</b>');
      this.unenrolledStudentLabel = translated.replace(/\{1\}/g, '&lt;&lt;Selected Year&gt;&gt;').replace('{2}', '&lt;&lt;District Name&gt;&gt;');
    }
  }
  // #endregion

  // #region Footer Methods
  addChildClick(isStudent: boolean) {
    const dialogBox = this.dialog.open(FrmaAddPersonComponent, {
      disableClose: true,
      data: {
        isStudent: isStudent,
        title: isStudent ? 'Add Student' : 'Add Child'
      }
    });

    dialogBox.afterClosed().pipe(take(1)).subscribe((newChild: FreeReducedMealAppChild) => {
      if (newChild) {
        newChild.Income = [];
        newChild.Programs = [];
        this.application.Children.push(newChild);
        this.application.Children = cloneDeep(this.application.Children);  // reassign as new object for change detection
        this.normalizeChildPrograms();
      }
    });
  }

  addAdultClick() {
    const dialogBox = this.dialog.open(FrmaAddPersonComponent, {
      disableClose: true,
      data: {
        title: 'Add Adult'
      }
    });

    dialogBox.afterClosed().pipe(take(1)).subscribe((newAdult: FreeReducedMealAppAdult) => {
      if (newAdult) {
        newAdult.Income = [];
        newAdult.IncomeTypeIds = [];
        this.application.Adults.push(newAdult);
        this.application.Adults = cloneDeep(this.application.Adults);  // reassign as new object for change detection
      }
    });
  }

  previousClick() {
    this.errors = [];
    this.changePage(this.getPreviousPageIndex());
  }

  // eslint-disable-next-line complexity
  getPreviousPageIndex(): number {
    const currentIndex = this.allPages.findIndex(o => o.ID == this.page.ID);
    let nextIndex = currentIndex - 1;
    switch (this.page.ID) {
      case FrmaPagesEnum.UseofInformationUSDANonDescrimination:
        if (this.application.Programs.find(o => o.Selected)) {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.AssistancePrograms);
        }
        else if (this.application.Children.every(o => o.IsFosterChild)) {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.FosterCare);
        }
        else if (this.application.Children.every(o => o.IsFosterChild || o.Programs.find(p => p.Selected) != null) && this.continueOrSubmit == 'Submit') {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.ContinueorSubmit);
        }
        break;
      case FrmaPagesEnum.AlmostDone:
        this.setSelectedAdult(this.application.Adults[this.application.Adults.length - 1]);
        nextIndex = this.getPreviousAdultIncomePageIndex();
        break;
      case FrmaPagesEnum.MilitaryIncome:
      case FrmaPagesEnum.EarningsFromWork:
      case FrmaPagesEnum.IncomeFromPublicAssistance:
      case FrmaPagesEnum.IncomeFromAlimonyorChildSupport:
      case FrmaPagesEnum.IncomeFromBenefits:
      case FrmaPagesEnum.RetirementIncome:
      case FrmaPagesEnum.OtherSourcesofIncome:
        nextIndex = this.getPreviousAdultIncomePageIndex();
        break;
      case FrmaPagesEnum.TheNextQuestionsAreAllAboutNameOfAdult:
        const nextAdultIndex = this.application.Adults.findIndex(o => o == this.selectedAdult);
        if (nextAdultIndex > 0) {
          this.setSelectedAdult(this.application.Adults[nextAdultIndex - 1]);
          nextIndex = this.getPreviousAdultIncomePageIndex();
        }
        else {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.WhatAdultsLiveInYourHousehold);
        }
        break;
      case FrmaPagesEnum.WhatAdultsLiveInYourHousehold:
        this.selectedChild = null;
        for (let i = this.application.Children.length - 1; i >= 0; i--) {
          if (this.application.Children[i].HasIncome && !this.selectedChild) {
            this.setSelectedChild(this.application.Children[i]);
          }
        }
        if (this.selectedChild) {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.DoesStudentHaveIncomeFromAnyOfTheFollowingSources);
        }
        else {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.TheNextFewQuestionsAreAboutYourChildrensIncome);
        }
        break;
      case FrmaPagesEnum.DoesStudentHaveIncomeFromAnyOfTheFollowingSources:
        let childFound = false;
        for (let i = this.application.Children.findIndex(o => o == this.selectedChild) - 1; i >= 0; i--) {
          if (this.application.Children[i].HasIncome && !childFound) {
            this.setSelectedChild(this.application.Children[i]);
            childFound = true;
          }
        }
        if (childFound) {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.DoesStudentHaveIncomeFromAnyOfTheFollowingSources);
        }
        else {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.TheNextFewQuestionsAreAboutYourChildrensIncome);
        }
        break;
        case FrmaPagesEnum.OtherChildrenInTheHousehold:
          if (this.application.Children.every(o => o.IsFosterChild || o.Programs.find(p => p.Selected) != null)) {
            nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.ContinueorSubmit);
          }
          else {
            nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.YourChildrenCanAlsoQualify);
          }
          break;
        case FrmaPagesEnum.CertifyandSubmit:
          if (this.mealApplicationConfidentiallyWaiverLookups && this.mealApplicationConfidentiallyWaiverLookups.length > 0) {
            nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.SharingInformationwithOtherPrograms);
          }
          else {
            nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.UseofInformationUSDANonDescrimination);
          }
          break;
      default:
        break;
    }
    return nextIndex;
  }

  getPreviousAdultIncomePageIndex(): number {
    const currentIndex = this.allPages.findIndex(o => o.ID == this.page.ID);
    let nextIndex = currentIndex - 1;
    if (currentIndex > this.allPages.findIndex(o => o.ID == FrmaPagesEnum.OtherSourcesofIncome) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.Other)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.OtherSourcesofIncome);
    }
    else if (currentIndex > this.allPages.findIndex(o => o.ID == FrmaPagesEnum.IncomeFromBenefits) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.Benefits)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.IncomeFromBenefits);
    }
    else if (currentIndex > this.allPages.findIndex(o => o.ID == FrmaPagesEnum.IncomeFromAlimonyorChildSupport) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.AlimonyChildSupport)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.IncomeFromAlimonyorChildSupport);
    }
    else if (currentIndex > this.allPages.findIndex(o => o.ID == FrmaPagesEnum.IncomeFromPublicAssistance) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.PublicAssistance)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.IncomeFromPublicAssistance);
    }
    else if (currentIndex > this.allPages.findIndex(o => o.ID == FrmaPagesEnum.EarningsFromWork) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.Employment)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.EarningsFromWork);
    }
    else if (currentIndex > this.allPages.findIndex(o => o.ID == FrmaPagesEnum.EarningsFromWork) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.Employment)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.EarningsFromWork);
    }
    else if (currentIndex > this.allPages.findIndex(o => o.ID == FrmaPagesEnum.MilitaryIncome) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.Military)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.MilitaryIncome);
    }
    else {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.TheNextQuestionsAreAllAboutNameOfAdult);
    }
    return nextIndex;
  }

  nextClick() {
    this.errors = [];
    this.validatePage(this.page);
    if (this.errors.length == 0) {
      this.setCompletedPage(this.page);
      this.changePage(this.getNextPageIndex());
    }
  }

  // eslint-disable-next-line complexity
  getNextPageIndex(): number {
    const currentIndex = this.allPages.findIndex(o => o.ID == this.page.ID);
    let nextIndex = currentIndex + 1;

    switch (this.page.ID) {
      case FrmaPagesEnum.AssistancePrograms:
        if (this.application.Programs.find(o => o.Selected)) {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.UseofInformationUSDANonDescrimination);
        }
        break;
      case FrmaPagesEnum.FosterCare:
        if (this.application.Children.every(o => o.IsFosterChild)) {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.UseofInformationUSDANonDescrimination);
        }
        break;
      case FrmaPagesEnum.YourChildrenCanAlsoQualify:
        if (this.application.Children.every(o => !o.IsStudent || o.IsFosterChild || o.Programs.find(p => p.Selected) != null)) {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.ContinueorSubmit);
        }
        else {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.OtherChildrenInTheHousehold);
        }
        break;
      case FrmaPagesEnum.ContinueorSubmit:
        if (this.continueOrSubmit == 'Continue') {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.OtherChildrenInTheHousehold);
        }
        else if (this.continueOrSubmit == 'Submit') {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.UseofInformationUSDANonDescrimination);
        }
        else {
          nextIndex = currentIndex;
        }
        break;
      case FrmaPagesEnum.TheNextFewQuestionsAreAboutYourChildrensIncome:
        this.selectedChild = null;
        for (let i = 0; i < this.application.Children.length; i++) {
          if (this.application.Children[i].HasIncome && !this.selectedChild) {
            this.setSelectedChild(this.application.Children[i]);
          }
        }
        if (this.selectedChild) {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.DoesStudentHaveIncomeFromAnyOfTheFollowingSources);
        }
        else {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.WhatAdultsLiveInYourHousehold);
        }
        break;
      case FrmaPagesEnum.DoesStudentHaveIncomeFromAnyOfTheFollowingSources:
        let childFound = false;
        for (let i = this.application.Children.findIndex(o => o == this.selectedChild) + 1; i < this.application.Children.length; i++) {
          if (this.application.Children[i].HasIncome && !childFound) {
            this.setSelectedChild(this.application.Children[i]);
            childFound = true;
          }
        }
        if (childFound) {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.DoesStudentHaveIncomeFromAnyOfTheFollowingSources);
        }
        else {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.WhatAdultsLiveInYourHousehold);
        }
        break;
      case FrmaPagesEnum.WhatAdultsLiveInYourHousehold:
        this.selectedAdult = null;
        if (this.application.Adults) {
          this.setSelectedAdult(this.application.Adults[0]);
        }
        break;
      case FrmaPagesEnum.TheNextQuestionsAreAllAboutNameOfAdult:
      case FrmaPagesEnum.MilitaryIncome:
      case FrmaPagesEnum.EarningsFromWork:
      case FrmaPagesEnum.IncomeFromPublicAssistance:
      case FrmaPagesEnum.IncomeFromAlimonyorChildSupport:
      case FrmaPagesEnum.IncomeFromBenefits:
      case FrmaPagesEnum.RetirementIncome:
      case FrmaPagesEnum.OtherSourcesofIncome:
        nextIndex = this.getNextAdultIncomePageIndex();
        break;
      case FrmaPagesEnum.UseofInformationUSDANonDescrimination:
        if (this.mealApplicationConfidentiallyWaiverLookups && this.mealApplicationConfidentiallyWaiverLookups.length > 0) {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.SharingInformationwithOtherPrograms);
        }
        else {
          nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.CertifyandSubmit);
        }
        break;
      default:
        break;
    }
    return nextIndex;
  }

  getNextAdultIncomePageIndex(): number {
    const currentIndex = this.allPages.findIndex(o => o.ID == this.page.ID);
    let nextIndex = currentIndex + 1;
    let nextAdultIndex = 0;
    if (this.selectedAdult) {
      nextAdultIndex = this.application.Adults.findIndex(o => o == this.selectedAdult) + 1;
    }
    if (currentIndex < this.allPages.findIndex(o => o.ID == FrmaPagesEnum.MilitaryIncome) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.Military)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.MilitaryIncome);
    }
    else if (currentIndex < this.allPages.findIndex(o => o.ID == FrmaPagesEnum.EarningsFromWork) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.Employment)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.EarningsFromWork);
    }
    else if (currentIndex < this.allPages.findIndex(o => o.ID == FrmaPagesEnum.IncomeFromPublicAssistance) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.PublicAssistance)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.IncomeFromPublicAssistance);
    }
    else if (currentIndex < this.allPages.findIndex(o => o.ID == FrmaPagesEnum.IncomeFromAlimonyorChildSupport) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.AlimonyChildSupport)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.IncomeFromAlimonyorChildSupport);
    }
    else if (currentIndex < this.allPages.findIndex(o => o.ID == FrmaPagesEnum.IncomeFromBenefits) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.Benefits)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.IncomeFromBenefits);
    }
    else if (currentIndex < this.allPages.findIndex(o => o.ID == FrmaPagesEnum.RetirementIncome) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.Retirement)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.RetirementIncome);
    }
    else if (currentIndex < this.allPages.findIndex(o => o.ID == FrmaPagesEnum.OtherSourcesofIncome) && this.selectedAdult.IncomeTypeIds.includes(FrmaAdultIncomeTypesEnum.Other)) {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.OtherSourcesofIncome);
    }
    else if (nextAdultIndex < this.application.Adults.length) {
      this.setSelectedAdult(this.application.Adults[nextAdultIndex]);
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.TheNextQuestionsAreAllAboutNameOfAdult);
    }
    else {
      nextIndex = this.allPages.findIndex(o => o.ID == FrmaPagesEnum.AlmostDone);
    }
    return nextIndex;
  }

  cancelClick() {
    this.errors = [];
    if (this.singlePageMode && !this.isDesignMode) {
      this.dialogRef.close(false); // this is a preview of a single page. No need to validate.
    }
    else {
      const canContinue = this.checkForErrorsGuard.checkForDeactivation(this);
      if (canContinue instanceof Observable) {
        canContinue.pipe(take(1)).subscribe(clickedOk => {
          if (clickedOk) {
            if (this.application.ID > 0) {
              this.dialogRef.close(false);  // existing app.  no need to refresh grid
            }
            else {
              this.dialogRef.close(this.appSaved);  // new app may have been saved.  need to refresh grid.
            }
          }
        });
      }
      else if (canContinue) {
        if (this.application.ID > 0) {
          this.dialogRef.close(false);  // existing app.  no need to refresh grid
        }
        else {
          this.dialogRef.close(this.appSaved);  // new app may have been saved.  need to refresh grid.
        }
      }
    }
  }

  closeClick() {
    this.dialogRef.close(true);
  }

  saveAndFinishLaterClick() {
    this.saveApp(true);
  }

  submitClick() {
    this.errors = [];
    this.validatePage(this.page);
    if (this.errors.length == 0) {
      this.application.Status = 'submitted';
      this.application.SubmittedBy = this.userService.currentUser.MemberId;
      this.application.SubmittedDate = new Date();
      this.application.Children.forEach(c => {
        if (c.Income) {
          c.Income.forEach(i => {
            i.ConvertedToAnnual = this.frmaService.convertIncomeToAnnual(i);
          });
        }
      });
      this.application.Adults.forEach(a => {
        if (a.Income) {
          a.Income.forEach(i => {
            i.ConvertedToAnnual = this.frmaService.convertIncomeToAnnual(i);
          });
        }
      });
      this.generatePDF();
    }
  }

  generatePDF() {
    this.eFormService.pdfDataURIs = [];
    this.spinnerService.showSpinner = true;
    this.printFlag = true;
    this.changePage(0);
  }

  saveApp(closeAfterSave: boolean) {
    if (!this.application.ID || this.application.ID <= 0) {
      this.application.CreatedBy = this.userService.currentUser.MemberId;
    }
    this.frmaService.saveFrmaApplication(this.application).pipe(take(1)).subscribe(newApp => {
      if (closeAfterSave) {
        this.dialogRef.close(true);
      }
    });
  }


  // #endregion

  // #region  Template Methods
  signatureBoxClick() {
    if (!this.isSigned) {
      this.application.SignedBy = null;
      this.application.SignedDate = null;
      this.application.SignedByName = '';
    }
    else {
      this.application.SignedBy = this.userService.currentUser.MemberId;
      this.application.SignedDate = new Date();
      this.application.SignedByName = this.frmaService.formatName(this.userService.currentUser.FirstName, null, this.userService.currentUser.LastName, this.userService.currentUser.Suffix);
    }
  }

  certifiedBoxClick() {
    if (!this.isCertified) {
      this.application.CertifiedBy = null;
      this.application.CertifiedDate = null;
      this.application.CertifiedByName = '';
    }
    else {
      this.application.CertifiedBy = this.userService.currentUser.Id;
      this.application.CertifiedDate = new Date();
      this.application.CertifiedByName = this.userService.currentUser.FirstName + ' ' + this.userService.currentUser.LastName;
    }
  }

  fosterCareChange(isFosterFamily: boolean) {
    this.isFosterFamily = isFosterFamily;
    if (!isFosterFamily) {
      this.application.Children.forEach(c => {
        c.IsFosterChild = false;
      });
    }
  }

  childProgramChange(isSelected: boolean, programId: number) {
    if (!isSelected) {
      this.application.Children.forEach(c => {
        const program = c.Programs.find(p => p.ProgramID == programId);
        if (program) {
          program.Selected = false;
        }
      });
    }
    switch (programId) {
      case FrmaProgramsEnum.McKinneyVento: {
        this.isMckinneyVento = isSelected;
        break;
      }
      case FrmaProgramsEnum.MEP: {
        this.isMEP = isSelected;
        break;
      }
      case FrmaProgramsEnum.RunawayYouth: {
        this.isRunawayYouth = isSelected;
        break;
      }
    }
  }

  deleteChildClick(child: FreeReducedMealAppChild) {
    const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });
    deleteConfirmDialog.componentInstance.headerLabel = 'Delete ' + (child.IsStudent ? 'Student' : 'Child');
    deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete ' + this.frmaService.formatName(child.FirstName, child.MiddleName, child.LastName, this.suffixPipe.transform(child.SuffixID, this.suffixes)) + '?';
    deleteConfirmDialog.componentInstance.okButtonLabel = 'Delete';
    deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
      if (deleteObject) {
        const i = this.application.Children.findIndex(o => o.ID == child.ID);
        if (i >= 0) {
          this.application.Children.splice(i, 1);
          this.application.Children = cloneDeep(this.application.Children);
        }
      }
    });
  }

  deleteAdultClick(adult: FreeReducedMealAppAdult) {
    const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });
    deleteConfirmDialog.componentInstance.headerLabel = 'Delete Adult';
    deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete ' + this.frmaService.formatName(adult.FirstName, adult.MiddleName, adult.LastName, this.suffixPipe.transform(adult.SuffixID, this.suffixes)) + '?';
    deleteConfirmDialog.componentInstance.okButtonLabel = 'Delete';
    deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
      if (deleteObject) {
        const i = this.application.Adults.findIndex(o => o.ID == adult.ID);
        if (i >= 0) {
          this.application.Adults.splice(i, 1);
          this.application.Adults = cloneDeep(this.application.Adults);
        }
      }
    });
  }

  selectedAdultdHasIncome(incomeTypeID: number): boolean {
    let hasIncome: boolean = null;
    if (this.selectedAdult) {
      if (this.selectedAdult.IncomeTypeIds.find(o => o == incomeTypeID) != null) {
        hasIncome = true;
      }
      else {
        if (this.application.ID > 0 && this.frmaService.pageHasBeenCompleted(this.application, this.page, this.selectedChild, this.selectedAdult)) {
          hasIncome = false;
        }
        else {
          const dict = this.frmaService.adultIncomeClicks[this.selectedAdult.ID];
          if (dict && dict[incomeTypeID] == true) {
            hasIncome = false;
          }
        }
      }
    }
    return hasIncome;
  }

  adultHasIncomeClick(incomeTypeID: number, hasIncome: boolean) {
    if (this.selectedAdult) {
      // for new applications we have to track if an answer was selected or not
      if (!this.frmaService.adultIncomeClicks[this.selectedAdult.ID]) {
        this.frmaService.adultIncomeClicks[this.selectedAdult.ID] = {};
      }
      this.frmaService.adultIncomeClicks[this.selectedAdult.ID][incomeTypeID] = true;
      if (hasIncome && !this.selectedAdult.IncomeTypeIds.find(o => o == incomeTypeID)) {
        this.selectedAdult.IncomeTypeIds.push(incomeTypeID);
      }
      else if (!hasIncome) {
        for (let i = this.selectedAdult.IncomeTypeIds.length - 1; i >= 0; i--) {
          if (this.selectedAdult.IncomeTypeIds[i] == incomeTypeID) {
            this.selectedAdult.IncomeTypeIds.splice(i, 1);
          }
        }
        const subTypeIds = this.allAdultIncomeSubTypes.filter(o => o.AdultIncomeTypeID == incomeTypeID).map(o => o.ID);
        for (let i = this.selectedAdult.Income.length; i >= 0; i--) {
          const income = this.selectedAdult.Income[i];
          if (income && subTypeIds.includes(income.AdultIncomeSubTypeID)) {
            this.selectedAdult.Income.splice(i, 1);
          }
        }
      }
    }
  }

  adultHasSubTypeClick(incomeSubTypeID: number, hasIncome: boolean) {
    if (this.selectedAdult) {
      if (hasIncome && !this.selectedAdult.Income.find(o => o.AdultIncomeSubTypeID == incomeSubTypeID)) {
        this.addAdultIncome(this.selectedAdult, incomeSubTypeID);
      }
      else if (!hasIncome) {
        for (let i = this.selectedAdult.Income.length - 1; i >= 0; i--) {
          if (this.selectedAdult.Income[i].AdultIncomeSubTypeID == incomeSubTypeID) {
            this.selectedAdult.Income.splice(i, 1);
          }
        }
      }
    }
  }

  addAdultIncome(adult: FreeReducedMealAppAdult, incomeSubTypeID: number) {
    if (adult && incomeSubTypeID) {
      const newIncome = new FreeReducedMealAppAdultIncome();
      newIncome.AdultIncomeSubTypeID = incomeSubTypeID;
      newIncome.AdultIncomeSubTypeID = adult.ID;
      if (!adult.Income) {
        adult.Income = [];
      }
      adult.Income.push(newIncome);
    }
  }

  selectedAdultdHasSubType(incomeSubTypeID: number): boolean {
    if (this.selectedAdult) {
      return this.selectedAdult.Income.find(o => o.AdultIncomeSubTypeID == incomeSubTypeID) != null;
    }
    else {
      return false;
    }
  }

  canShareStudentInfo(program: FreeReducedMealAppInfoSharing, child: FreeReducedMealAppChild) {
    if (program && child && program.StudentIds && child.StudentID > 0) {
      return program.StudentIds.includes(child.StudentID);
    }
    return false;
  }


  shareInfoClick(program: FreeReducedMealAppInfoSharing, child: FreeReducedMealAppChild) {
    if (program && program.ShareWith == 'selected' && child && child.StudentID > 0) {
      if (!program.StudentIds) {
        program.StudentIds = [];
      }
      const i = program.StudentIds.findIndex(o => o == child.StudentID);
      if (i >= 0) {
        program.StudentIds.splice(i, 1);
      }
      else {
        program.StudentIds.push(child.StudentID);
      }
    }
  }

  shareWithRadioClick(program: FreeReducedMealAppInfoSharing, shareWith: string) {
    if (program) {
      program.ShareWith = shareWith;
      if (shareWith != 'selected') {
        program.StudentIds = [];
      }
    }
  }

  checkErrors(nextState?: RouterStateSnapshot): number {
    const customizer = (objValue: any, otherValue: any, index: any, obj: any): boolean => {
      if (index == 'CompletedPages') {
        return true;
      }
      if (!isEqual(objValue, otherValue)) {
        return undefined;
      }
      return undefined;
    };
    if (isEqualWith(this.application, this.originalApplication, customizer)) {
      return 2;
    }
    else {
      return 0;
    }
  }

  continuedWithoutSave() { }

  save() {
    this.appSaved = true;
    this.saveApp(true);
  }

  unenrolledStudentClick(student: FreeReducedMealAppChild) {
    if (student.isSelected) {
      this.application.Children.push(cloneDeep(student));
    }
    else {
      const i = this.application.Children.findIndex(o => o.StudentID == student.StudentID);
      if (i >= 0) {
        this.application.Children.splice(i, 1);
      }
    }
  }

  // #endregion

}
